export function toggleTheme(theme, setTheme) {
	const next = theme === "light" ? "dark" : "light";
	setTheme(next);
	document.documentElement.setAttribute("data-theme", next);
	window.localStorage.setItem("catsoup-radio-theme", next);
}